const customers = {
  breadcrumb: {
    root: "Customers",
    new: "New customer",
    detail: "Customer",
    favorites: "Featured",
    offers: "Offers",
  },
  list: {
    title: "Customer directory",
    alert:
      "Save your customers' details to contact them and reuse their information whenever you need it.",
    groups: "Groups",
    favorites: "Featured",
    offers: "Offers",
    member: "member",
    members: "members",
    contacts: "Contacts",
    select: "Select",
    cancel: "Cancel",
    selectAll: "Select all",
    emptyTitle: "You don't have customers yet",
    emptyDescription: "Create your first customer to start managing your directory.",
    emptyCta: "Create customer",
    loading: "Loading customers...",
    loadError: "Customers could not be loaded",
    retry: "Retry",
    create: "Create customer",
  },
  detail: {
    newTitle: "New customer",
    editTitle: "Customer",
    typeLabel: "Customer type",
    person: "Person",
    business: "Business",
    save: "Save",
    favorite: "Featured",
    delete: "Delete",
    saved: "Customer saved",
    deleted: "Customer deleted",
    saveError: "The customer could not be saved",
    deleteError: "The customer could not be deleted",
    notFound: "We couldn't find this customer",
    backToList: "Back to directory",
  },
  form: {
    name: "Name",
    email: "Email",
    phone: "Phone",
    businessName: "Business name",
    adminName: "Administrator name",
    businessCode: "Tax ID or code",
    businessEmail: "Email",
    city: "City",
    address: "Address",
    businessPhone: "Business phone",
    adminPhone: "Administrator phone",
    nameRequired: "Name is required",
    phoneRequired: "Phone is required",
    emailInvalid: "Enter a valid email",
    adminNameRequired: "Administrator name is required",
    businessCodeRequired: "Tax ID or code is required",
    addressRequired: "Address is required",
  },
  contact: {
    whatsapp: "WhatsApp",
    email: "Email",
    call: "Call",
    whatsappMessage: "Hello",
  },
  deleteModal: {
    title: "Delete customers?",
    description: "This action cannot be undone. Do you want to continue?",
    cancel: "No",
    confirm: "Delete",
    success: "Customers deleted",
    error: "Customers could not be deleted",
  },
};

export default customers;
